import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        // 宿主来源 默认app
        source:'app',

    },
    mutations: {
        setSource(state, value){
            state.source = value
        },
    },
    getters: {},
    actions: {},
    modules: {},
    plugins: [createPersistedState({
        storage: window.sessionStorage
    })]
})

